var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJackpot(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcc00",
    d: "M49.64,50H14.36c-.75,0-1.36.68-1.36,1.5v3c0,.82.61,1.5,1.36,1.5h35.29c.75,0,1.36-.68,1.36-1.5v-3c0-.82-.61-1.5-1.36-1.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcc00",
    d: "M55.8,19.69c-2.32,0-4.2,1.96-4.2,4.38,0,.65.14,1.25.39,1.81l-6.34,3.96c-1.35.84-3.09.37-3.87-1.06l-7.13-13.03c.94-.8,1.55-2.01,1.55-3.38,0-2.42-1.88-4.38-4.2-4.38s-4.2,1.96-4.2,4.38c0,1.37.61,2.58,1.55,3.38l-7.13,13.03c-.78,1.43-2.53,1.9-3.87,1.06l-6.33-3.96c.24-.55.39-1.16.39-1.81,0-2.42-1.88-4.38-4.2-4.38s-4.21,1.96-4.21,4.38,1.88,4.38,4.2,4.38c.23,0,.46-.04.67-.07l6.33,17.61h33.6l6.33-17.61c.22.04.45.07.67.07,2.32,0,4.2-1.96,4.2-4.38s-1.88-4.38-4.2-4.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJackpot);
export default __webpack_public_path__ + "static/media/Jackpot.68cce000bea843bdc89070c88ddce566.svg";
export { ForwardRef as ReactComponent };